import * as React from "react"

export const AgenciesIcon = ({
  width = 40,
  height = 40,
  ...rest
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...rest}
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width={width} height={height} rx="8" fill="#F9F2FF" />

    <path
      d="M20.5 22C24.366 22 27.5 18.866 27.5 15C27.5 11.134 24.366 8 20.5 8C16.634 8 13.5 11.134 13.5 15C13.5 18.866 16.634 22 20.5 22Z"
      stroke="#7026B9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.71 20.8899L15.5 29.9999L20.5 26.9999L25.5 29.9999L24.29 20.8799"
      stroke="#7026B9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
